<!--
 * @Desc:
 * @Author: 赵佳明
 * @Date: 2024-04-22 14:53:52
 * @LastEditors: 赵佳明
 * @LastEditTime: 2024-04-24 14:38:42
-->
<template>
    <div class="pege-tongji">
        <div class="page-top">
            <div class="list dis">
                <div class="item" v-for="(item, index) in num_count" :key="index">
                    <div class="name">{{ item.name || '' }}</div>
                    <div class="num">{{ item.num || '' }}</div>
                </div>
            </div>
            <div class="list dis">
                <div class="item" v-for="(item, index) in score_count" :key="index">
                    <div class="name">{{ item.name || '' }}</div>
                    <div class="num">{{ item.num || '' }}</div>
                </div>
            </div>
        </div>
        <!-- 题统计 -->
        <div class="shai dis">
            <div class="shaixuan-item">
                    <el-select v-model="community_id" clearable filterable placeholder="请选择小区">
                        <el-option v-for="item in optionList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </div>
                <div class="shaixuan-item">
                    <el-button type="primary" @click="handleFilter" icon="el-icon-search">
                        {{ $t("table.search") }}
                    </el-button>
                </div>
        </div>
        <div class="page-ti dis">
            <div class="ti-item dis" v-for="(item, index) in tiList" :key="index">
                <div :class="item.type == 3 ? 'left-ti tiankong' : 'left-ti'">
                    <div class="biaoti">{{ index + 1 }}、{{ item.name }}({{ item.type == 1 ? '单选' : item.type == 2 ? '多选'
                    : '填空' }})</div>
                    <div class="fen" v-if="item.type!=3">平均得分：{{ item.avg_score || 0 }}</div>
                    <div class="xuan-list" v-if="item.type == 1 || item.type == 2">
                        <div class="xuan" v-for="(xuan, int) in item.option" :key="int">
                            <span>选项{{ int + 1 }}:</span>
                            <span>{{ xuan.name || '' }}</span>
                            <span>{{ xuan.num || 0 }}人</span>
                            <span>{{ xuan.rate || 0 }}%</span>
                        </div>
                    </div>
                    <div class="info-btn" v-if="item.type == 3" @click="toInfo(item.id)">查看详情</div>
                </div>
                <!-- 统计 -->
                <div class="right-tong" :id="'tongbox' + index" style="width:50%;height: 250px;" v-if="item.type != 3">
                </div>
            </div>
        </div>
        <!-- 填空回答弹出框 -->
        <el-dialog title="填空" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false">
            <div class="tiankong-con">
                <el-table v-loading="listLoading" :data="tianList" style="width: 100%">
                    <el-table-column prop="content" label="内容" align="left" min-width="200" />

                </el-table>
                <!-- 分页 -->
                <pagination v-show="total" :total="total" :page.sync="pages.page" :limit.sync="pages.size"
                    @pagination="getTian" />
            </div>
            <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination';
import guanli from "@/api/tianzheng/guanli";
export default {
    components: {
        Pagination
    },
    data() {
        return {
            survey_id: "",//问卷id
            community_id: "",//小区id
            optionList: [],///当前小区下拉数据
            num_count: [],//个数统计
            score_count: [],//分数统计
            tiList: [],//统计下面的题
            tiId: "",//填空id
            dialogVisible: false,//填空弹出框
            total: 0,
            pages: {
                page: 1,
                size: 10
            },
            listLoading: false,//弹出表格加载
            tianList:[],//填空内容数据
        }
    },
    created() {
        this.survey_id = this.$route.query.id;//问卷id
        this.getTopcount()//统计-上面数字
        this.getTicount()//统计-下面题
        this.getSelectCity()//获取小区下拉列表
    },
    methods: {
        // 点击搜索
        handleFilter(){
            this.tiList = [];
            this.getTicount();
        },
          // 获取小区下拉列表
          getSelectCity() {
            guanli.communitySelect({ survey_id: this.survey_id }).then(res => {
                if (res.code == 200) {
                    this.optionList = res.result;
                }
            })
        },
        // 统计-上面数字
        getTopcount() {
            let that = this;
            guanli.topCount({ id: that.survey_id }).then(res => {
                if (res.code == 200) {
                    that.num_count = res.result.num_count;
                    that.score_count = res.result.score_count;
                }
            })
        },
        // 统计-下面题
        getTicount() {
            let that = this;
            guanli.tiCount({ id: that.survey_id, community_id: that.community_id }).then(res => {
                if (res.code == 200) {
                    that.tiList = res.result;
                    setTimeout(() => {
                        for (var i in res.result) {
                            if (res.result[i].type != 3) {
                                let item = res.result[i].chart;
                                that.initTong(item, i)
                            }
                        }
                    }, 300);
                }
            })
        },
        // 点击查看详情
        // id:题id
        toInfo(id) {
            this.tiId = id;
            this.dialogVisible = true;
            this.tianList=[];
            this.pages.page=1;
            this.listLoading = true;
            this.getTian()
        },
        // 获取填空回答数组
        getTian() {
            let that = this;
            guanli.tianList({ page: that.pages.page, size: that.pages.size, id: that.survey_id, ti_id: that.tiId, community_id: that.community_id }).then(res => {
                if (res.code == 200) {
                    that.listLoading = false;
                    that.tianList = res.result.list;
                    that.total = res.result.total;
                }else{
                    that.listLoading = true;
                }
            })
        },
        initTong(item, i) {
            console.log("item", item, i);
            let chartDom = document.getElementById("tongbox" + i);
            let myChart = echarts.init(chartDom);
            let option;
            option = {
                y: '5%',//颜色块下移
                title: {
                    text: '',
                    subtext: '',
                    left: 'center',
                    bottom: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    // orient: 'vertical',
                    // left: 'left'
                    show: true,//指示点
                    bottom: 0,
                    left: "center",
                    icon: "circle",
                    itemWidth: 8,
                    itemHeight: 8
                },
                series: [
                    {
                        name: '',
                        type: 'pie',
                        radius: '50%',
                        data: item,
                        // 指示线
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            option && myChart.setOption(option);
        }
    },
}
</script>

<style scoped>
.pege-tongji {
    padding: 20px;
}

.page-top {
    background: #fff;
    padding: 20px;
    border-radius: 5px;
}

.page-top .list {
    flex-wrap: wrap;
}

.dis {
    display: flex;
    align-items: center;
}

.page-top .list .item {
    border-radius: 5px;
    border: 1px solid #ddd;
    margin-right: 20px;
    margin-bottom: 20px;
}

.page-top .list .item .name {
    border-bottom: 1px solid #ddd;
    font-size: 18px;
    line-height: 30px;
    padding: 0 30px;
}

.page-top .list .item .num {
    font-size: 18px;
    line-height: 40px;
    text-align: center;
}

.page-ti {
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 20px;
    align-items: flex-start;
}

.page-ti .ti-item {
    background: #fff;
    width: 49%;
    padding: 20px;
    margin-bottom: 20px;
}

.page-ti .ti-item .left-ti {
    width: 50%;
}

.page-ti .ti-item .left-ti.tiankong {
    width: 100%;
}

.page-ti .ti-item .left-ti .biaoti {
    font-size: 16px;
    line-height: 40px;
}

.page-ti .ti-item .left-ti .fen {
    margin-bottom: 20px;
}

.page-ti .ti-item .left-ti .xuan {
    line-height: 30px;
}

.page-ti .ti-item .info-btn {
    background: #13ce66;
    color: #fff;
    width: 100px;
    line-height: 30px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
}
.pege-tongji .shai{
    background: #fff;
    padding: 20px;
    margin-top: 20px;
}
.pege-tongji .shai .shaixuan-item{
    margin-right: 15px;
}
</style>
